export class ProjectDirectoryPage {

    dataTable: any;

    constructor() {

        $(() => {

            this.dataTable = $('#users-table').DataTable({
                "dom": '<"top-controls"<"reset-section">Bf>rtip',
                autoWidth: false,
                order: [[1, "asc"]],
                info: false,
                paging: false,
                scrollX: true,
                //"columnDefs": [
                    //{ "orderable": false, "targets": 8 }, //don't want to sort actions column
                    //{ "width": "85px", "targets": 6 }, //last login column can be fixed width
                    //{ "width": "25px", "targets": 7 } //status column can be fixed width
                //]
                buttons: [
                    {
                        extend: 'csv',
                        text: '<i class="fas fa-file-csv"></i>',
                        titleAttr: 'CSV',
                        charset: 'utf-8',
                        exportOptions: {
                            columns: [0, 1, 2, 3, 4]
                        }
                    }
                    , {
                        text: '<i class="fas fa-envelope"></i>',
                        titleAttr: 'Create Email List',
                        charset: 'utf-8',
                        action: (e, dt, node, config) => {
                            this.copyVisibleEmailToClipboard();
                        }
                    }
                    ]
            });

            let resetSectionDiv: string =
                "<div>" +
                "<button type=\"button\" class=\"btn btn-sm btn-outline-secondary font-size12\" onclick=\"page.resetFilters()\">Reset Filters</button>&nbsp;&nbsp;&nbsp;<span class=\"font-italic font-size12 font-weight-bold\" id=\"users-found-count\"></span>" +
                "</div>"
                ;
            $(".reset-section").empty().html(resetSectionDiv);
            $(".reset-section").css('display', 'inline-block');
            $(".reset-section").css('float', 'left');
            $(".reset-section").css('margin-top', '5px');

            $('#users-table').on('search.dt', (e, settings) => {
                this.setUsersFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
            });

            this.initializeFilters();
        });
    }

    initializeFilters(): void {

        for (let index = 2; index <= 3; ++index) { //filter on organization and affiliation
            let selectId: string = '#filter-dropdown-' + index;
            let filterIndex: number = index;

            let uniqueValues: string[] = [];
            let delimiter: string = ",";


            let dropdownSourceIndex: number = index;

            this.dataTable.column(dropdownSourceIndex).data().unique().map((data: string) => {
                let parts: string[] = [];
                if (delimiter != "") { parts = data.split(delimiter); }
                else { parts[0] = data; }

                parts.map((part: string) => {
                    part = part.trim();
                    if (part.length > 0 && !uniqueValues.includes(part)) {
                        uniqueValues.push(part);
                    }
                });
            });

            uniqueValues = uniqueValues.sort((a: string, b: string) => {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            uniqueValues.forEach((element: any) => {
                $(selectId).append(new Option(element, element, false, true));
            });




            $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
                let values: string[] = <string[]>($(selectId).val());
                //console.log("changed", values);

                let search: string = "";

                if (values.length > 0) {
                    search = "(\\b" + values.join("\\b)|(\\b") + "\\b)";
                }
                else { search = "NOTHING-MATCHED-1234567890"; }
                console.log("search1 ", search);
                search = search.split("(").join("").split(")").join("");
                console.log("search2 ", search);
                this.dataTable.column(filterIndex)
                    .search(search, true, false)
                    .draw();
            });


            $(selectId).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });

            $(selectId).selectpicker("refresh");

          

        }
    }

    resetFilters(): void {
        let filterIndex: number;
        for (let index = 3; index >= 2; --index) { //skip details and title column

            $('#filter-dropdown-' + index).selectpicker('selectAll');
            $('#filter-dropdown-' + index).selectpicker("refresh");

            filterIndex = index;
            this.dataTable.column(filterIndex).search('').draw();
        }
        this.dataTable.search('').draw();
    }

    setUsersFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#users-found-count').text("Nobody Found"); break;
            case 1: $('#users-found-count').text("1 Person Found"); break;
            default: $('#users-found-count').text(count + " People Found");
        }
    }

    copyVisibleEmailToClipboard(): void {
        let visibleUsers = this.dataTable.rows({ search: 'applied' }).data().toArray();
        console.log(visibleUsers);
        let emailList: string[] = new Array();

        visibleUsers.forEach(function (item) {
            emailList.push(item[1]);
        });

        let emailListString: string = emailList.join("; ");

        navigator.clipboard.writeText(emailListString)
            .then(() => {
                $('#emailListValue').text(emailListString);
                $('#directory-email-modal').modal('show');
            },
                () => {
                    alert("There was an error copying to the clipboard. Please try again.");
                });
    }
}